import AppHeader from "../../layout/AppHeader";
import TagsGenerate from '../../xpost/views/services/tag/TagsGenerate.vue';

const TagsRoutes = [
  {
    path: "/servicos/etiquetas",
    name: "tags.generate",
    components: {
      header: AppHeader,
      default: TagsGenerate
    }
  },
]

export default TagsRoutes;